export class StudentQuotaHours {
    id: number;
    active: boolean;
    maxHours: number;
    year : number;
  }